module.exports = __webpack_public_path__ + "static/media/6.8fad24a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/minsk/6.jpg
// module id = 232
// module chunks = 0